<div mat-dialog-content>There was an error while saving your form</div>
<div mat-dialog-actions style="text-align: center;padding: 1em;">
    <button mat-raised-button id="button" mat-dialog-close (click)="closeErrorMsg()">Ok</button>
</div>